import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const { t } = useLanguage();

  const scrollDown = () => {
    window.scrollTo({ top: window.innerHeight * 0.8, behavior: 'smooth' });
  };

  return (
    <section 
      data-testid="hero-section"
      className="relative flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: '#050A14', minHeight: '100dvh', paddingTop: '80px', boxSizing: 'border-box' }}
    >
      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Tagline */}
        <p 
          data-testid="hero-tagline"
          className="font-body text-xs tracking-[0.4em] uppercase mb-12 opacity-0 animate-fade-in"
          style={{ color: '#6B7280' }}
        >
          {t('hero.tagline')}
        </p>

        {/* Main Title */}
        <h1 
          data-testid="hero-title"
          className="font-heading text-6xl md:text-7xl lg:text-8xl font-light tracking-wide mb-8 opacity-0 animate-fade-in delay-200"
        >
          <span className="silver-gradient-text silver-glow">{t('hero.title')}</span>
        </h1>

        {/* Subtitle */}
        <p 
          data-testid="hero-subtitle"
          className="font-heading text-lg md:text-xl tracking-[0.15em] mb-16 opacity-0 animate-fade-in delay-300 italic"
          style={{ color: '#9CA3AF' }}
        >
          {t('hero.subtitle')}
        </p>

        {/* Elegant divider */}
        <div className="divider-silver w-24 mx-auto mb-16 opacity-0 animate-fade-in delay-400" />

        {/* Description */}
        <p 
          data-testid="hero-description"
          className="font-body text-base md:text-lg max-w-xl mx-auto mb-16 leading-relaxed opacity-0 animate-fade-in delay-500"
          style={{ color: '#6B7280' }}
        >
          {t('hero.description')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 opacity-0 animate-fade-in delay-700">
          <Link
            to="/postuler"
            data-testid="hero-cta-primary"
            className="btn-silver"
          >
            {t('hero.cta')}
          </Link>
          <Link
            to="/agence"
            data-testid="hero-cta-secondary"
            className="btn-outline"
          >
            {t('hero.ctaSecondary')}
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollDown}
        data-testid="scroll-indicator"
        className="absolute bottom-10 left-1/2 -translate-x-1/2 transition-colors"
        style={{ color: '#4B5563' }}
      >
        <ChevronDown size={28} strokeWidth={1} />
      </button>

      {/* Subtle side accents */}
      <div className="absolute top-1/3 left-8 w-px h-24 hidden lg:block" style={{ background: 'linear-gradient(to bottom, transparent, rgba(156, 163, 175, 0.1), transparent)' }} />
      <div className="absolute top-1/2 right-8 w-px h-24 hidden lg:block" style={{ background: 'linear-gradient(to bottom, transparent, rgba(156, 163, 175, 0.1), transparent)' }} />
    </section>
  );
};

export default HeroSection;
